import { WFPButton } from "@/components/ui/button";

interface RepresentativeFormActionsProps {
  isOnEdit: boolean;
  backLabel: string;
  createLabel: string;
  isSubmitting?: boolean;
  updateLabel: string;
  onBack: () => void;
}

export const RepresentativeFormActions = ({
  isOnEdit,
  backLabel,
  createLabel,
  isSubmitting = false,
  updateLabel,
  onBack,
}: RepresentativeFormActionsProps) => (
  <div className="flex justify-end gap-3 pt-2">
    {isOnEdit ? (
      <WFPButton type="button" variant="secondary" disabled={isSubmitting} onClick={onBack}>
        {backLabel}
      </WFPButton>
    ) : null}
    <WFPButton type="submit" disabled={isSubmitting}>
      {isOnEdit ? updateLabel : createLabel}
    </WFPButton>
  </div>
);
